import modeEnum from "Areas/Documents/documentEditorPanel/mode";
import { shadingLightestColor } from "Common/componentUtils/modalUtils";
import Button from "Components/button";
import { TextWidget, hasEmptyRequiredFields } from "Components/optionForm";
import WithModal from "Components/withModal";
import cloneDeep from "lodash/cloneDeep";
import isUndefined from "lodash/isUndefined";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { NEW_FOLDER, requiredFields } from "../constants";
import locale from "./folderEditorPanel.locale";
export const SIZES = {
    MODAL_WIDTH: 400,
    MODAL_HEIGHT: 197
};
const titleMap = {
    [modeEnum.CREATE]: locale.CREATE_FOLDER,
    [modeEnum.EDIT]: locale.EDIT_FOLDER
};
const saveButtonText = {
    [modeEnum.CREATE]: locale.CREATE,
    [modeEnum.EDIT]: locale.SAVE
};
const gridStyle = { gridTemplateRows: "1fr auto" };
export default function FolderEditorPanel(props) {
    const title = useMemo(() => (props.mode ? titleMap[props.mode] : ""), [props.mode]);
    const [show, setShow] = useState(false);
    const [hasChanges, setHasChanges] = useState(false);
    const draftNew = useMemo(() => ({
        ...NEW_FOLDER,
        DocumentId: props.documentId || 0
    }), [props.documentId]);
    const [draft, setDraft] = useState(draftNew);
    useEffect(() => {
        props.folderId &&
            props.folders &&
            props.folders[props.folderId] &&
            setDraft(props.mode !== modeEnum.EDIT ? cloneDeep(draftNew) : props.folders[props.folderId]);
        (!props.folderId || !props.mode) && setDraft(cloneDeep(draftNew));
        setShow(!isUndefined(props.folderId) && !isUndefined(props.mode));
    }, [props.folders, props.folderId, props.mode]);
    const handleHideModal = useCallback((e) => {
        if (e)
            props.onClose && props.onClose();
        else
            setShow(false);
    }, [props.onClose]);
    const isEmptyRequiredFields = hasEmptyRequiredFields(draft, requiredFields);
    const handleChangeDraft = useCallback((value, fieldName) => {
        if (!fieldName)
            return;
        setDraft(prev => ({
            ...prev,
            [fieldName]: value
        }));
        setHasChanges(true);
    }, []);
    const handleSave = useCallback(() => {
        props.mode &&
            draft &&
            props.onSaveFolder &&
            !isUndefined(props.documentId) &&
            props.onSaveFolder(draft);
    }, [draft, props.mode]);
    const handleCancel = useCallback(() => {
        setDraft(cloneDeep(props.mode === modeEnum.EDIT &&
            !isUndefined(props.folderId) &&
            !isUndefined(props.folders) &&
            props.folders[props.folderId]
            ? props.folders[props.folderId]
            : draftNew));
        setHasChanges(false);
    }, [props.mode, props.folderId, props.folders]);
    if (!props.mode)
        return null;
    return (React.createElement(WithModal, { show: show, onHide: handleHideModal, contentClassName: "modal-padding", shadingColor: shadingLightestColor, className: "bg-blur", title: title, defaultWidth: SIZES.MODAL_WIDTH, defaultHeight: SIZES.MODAL_HEIGHT, isLoading: props.inProgress },
        React.createElement("div", { className: "d-grid", style: gridStyle },
            React.createElement(TextWidget, { value: (draft === null || draft === void 0 ? void 0 : draft.Name) || "", fieldName: "Name", onChange: handleChangeDraft, label: locale.NAME_PLACEHOLDER, labelMode: "floating", height: 44 }),
            React.createElement("div", { className: "d-flex justify-content-flex-end with-gap-8 mt-gap" },
                React.createElement(Button, { className: "btn-h-m p-8-24", text: locale.CANCEL, onClick: handleCancel, disabled: !hasChanges, minWidth: 101 }),
                React.createElement(Button, { text: saveButtonText[props.mode], className: "btn-primary btn-h-m p-8-24", disabled: isEmptyRequiredFields || !hasChanges, onClick: handleSave, minWidth: 123 })))));
}
